import { createFileRoute } from "@tanstack/react-router";
import { PROFILE_ID, ProfilePage } from "@/features/profiles/components/ProfilePage";
import { profileQuery } from "@/features/profiles/queries";

export const Route = createFileRoute("/_authenticated/profiles/$profileId")({
  // Not awaited, so the page opens on its skeleton rather than waiting on the request.
  loader: ({ context: { queryClient }, params: { profileId } }) => {
    if (PROFILE_ID.test(profileId)) void queryClient.prefetchQuery(profileQuery(profileId));
  },
  head: () => ({ meta: [{ title: "Profile · Pax.co" }] }),
  component: ProfileRoute,
});

function ProfileRoute() {
  const { profileId } = Route.useParams();
  return <ProfilePage profileId={profileId} />;
}
